export const TargetObjectTypes = Object.freeze({
  egroups: "egroups",
  identities: "identities",
  accounts: "accounts",
  applications: "applications",
});
